import script from "./OwnerShipDetailList.vue?vue&type=script&setup=true&lang=js"
export * from "./OwnerShipDetailList.vue?vue&type=script&setup=true&lang=js"

import "./OwnerShipDetailList.vue?vue&type=style&index=0&id=1693e30c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1693e30c"]])

export default __exports__